import * as React from 'react';
import { IconCircle } from '../../../../../../../../../components/Icons/IconCircle';

interface IMTAMTACardHeader {
  text: string;
  showDefaqto?: boolean;
  cancel?: boolean;
  icon?: string;
  subtext?: any;
  noIcon?: boolean;
  border?: boolean;
}

export const MTACardHeader = ({
                                text,
                                showDefaqto = false,
                                cancel = false,
                                icon = '',
                                subtext,
                                noIcon,
                                border = false
                              }: IMTAMTACardHeader) => {

  let iconComponent;

  if (icon) {
    iconComponent = <img src={require(`../../../../../Images/${icon}.svg`)} width={'45px'} alt={''}/>
  } else {
    iconComponent = cancel ? <img src={require('../../../../../Images/document.svg')} width={'60px'} alt={''}/> :
      <IconCircle iconName={'person.svg'} color={'blue'}/>
  }

  if (noIcon) {
    iconComponent = null;
  }

  return (
    <div className={'mta-details-overview'}>
      <div className={border ? 'mta-details-overview-header border-bottom' : 'mta-details-overview-header'}>
        {iconComponent && (
          <div className={'mta-overview-icon'}>
            {iconComponent}
          </div>
        )}
        <div>
          <>
            <span className={'mta-overview-text'}>{text}</span>
            {subtext && (
              <div>{subtext}</div>
            )}
          </>
        </div>
        {showDefaqto && (
          <div className={'cancel-policy-image-container'}>
            <img height={'80px'} src={require('../../../../../Images/defaqto.svg')} alt={'Admiral'}/>
            <div className={'cancel-policy-image-text'}>Admiral Annual - Platinum</div>
          </div>
        )}
      </div>
    </div>
  )
}
